<template>
	<div
		class="g-block-quick-nav-grid"
		:class="{
			'g-block-quick-nav-grid--edit': editable,
			'is-active': editable && active,
			'g-block-quick-nav-grid--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			v-for="(item, index) in items"
			:key="item.id"
			class="g-block-quick-nav-grid__item"
			@click="onItemClick($event, item)"
		>
			<div class="g-block-quick-nav-grid__icon">
				<img v-if="getImageUrl(item)" :src="getImageUrl(item)" alt="" />
			</div>
			<div
				class="g-block-quick-nav-grid__text"
				:style="{ color: item.textColor }"
			>{{ item.text }}</div>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import {
		getQuickNavImageUrl,
		normalizeQuickNavGridData,
	} from '../../../utils/quickNav.js';

	export default {
		name: 'GQuickNavGridShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			items() {
				return normalizeQuickNavGridData(this.data).items;
			},
		},
		methods: {
			getImageUrl(item) {
				return getQuickNavImageUrl(item.image);
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onItemClick(e, item) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && item.jumpLink?.type) {
					e?.stopPropagation?.();
					navigateJumpLink(item.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-quick-nav-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 20px 8px;
		padding: 16px 12px;
		background: #fff;
		box-sizing: border-box;
		border-radius: 4px;

		&--edit {
			border: 1px solid transparent;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}

		&--h5 {
			gap: 0.4rem 0.16rem;
			padding: 0.32rem 0.24rem;
			border-radius: 0.08rem;
		}
	}

	.g-block-quick-nav-grid__item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		min-width: 0;
		cursor: pointer;
		box-sizing: border-box;

		.g-block-quick-nav-grid--h5 & {
			gap: 0.16rem;
		}
	}

	.g-block-quick-nav-grid__icon {
		width: 55px;
		height: 55px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			display: block;
		}

		.g-block-quick-nav-grid--h5 & {
			width: 1.1rem;
			height: 1.1rem;
			border-radius: 0.08rem;
		}
	}

	.g-block-quick-nav-grid__text {
		width: 100%;
		font-size: 14px;
		line-height: 1.4;
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #666;

		.g-block-quick-nav-grid--h5 & {
			font-size: 0.28rem;
		}
	}
</style>
